/*
  GP custom: viewport-trigger product-card media peek.

  The product-card media peek animation lives in CSS, but CSS alone starts the
  animation as soon as the page loads. For below-fold feeds, that can finish
  before the customer sees the card.

  This file keeps JavaScript deliberately small and isolated:
  - Find product-card carousels marked with `.gp-card-media-carousel--peek`.
  - Watch them with IntersectionObserver.
  - When one enters the viewport, add `.gp-card-media-carousel--peek-ready`.
  - CSS listens for that ready class and runs the keyframe animation.

  This script does not read, call, or modify Swiper instances. It only toggles
  GP-owned classes on GP-owned markup so vendor carousel behavior remains in
  charge of touch/drag mechanics.
*/
(() => {
  const peekSelector = ".gp-card-media-carousel--peek";
  const readyClass = "gp-card-media-carousel--peek-ready";
  const observedAttribute = "data-gp-peek-observed";

  const prefersReducedMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const markReady = (element) => {
    element.classList.add(readyClass);
    element.removeAttribute(observedAttribute);
  };

  const observePeekTargets = (root = document) => {
    const targets = root.querySelectorAll(
      `${peekSelector}:not(.${readyClass}):not([${observedAttribute}])`
    );

    if (targets.length === 0) return;

    if (prefersReducedMotion() || !("IntersectionObserver" in window)) {
      targets.forEach(markReady);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          markReady(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.45 }
    );

    targets.forEach((target) => {
      target.setAttribute(observedAttribute, "true");
      observer.observe(target);
    });
  };

  document.addEventListener("DOMContentLoaded", () => observePeekTargets());
  document.addEventListener("shopify:section:load", (event) => {
    observePeekTargets(event.target);
  });
})();
